import { useEffect } from "react";
import {
  listenMessages,
  requestPermission,
} from "../../firebase/messaging";

export default function NotificationHandler() {
  useEffect(() => {
    let unsubscribe = null;

    const init = async () => {
      try {
        console.log("🚀 Initializing FCM...");

        // ================= REQUEST PERMISSION =================
        const token = await requestPermission();

        console.log("🔥 FCM TOKEN:", token);

        if (!token) {
          console.log("❌ Token not found");
          return;
        }

        // ================= FOREGROUND LISTENER =================
        unsubscribe = listenMessages((payload) => {
          console.log("🔥 FIREBASE PAYLOAD:", payload);

          // ================= SAFE DATA PARSE =================
          const title =
            payload?.title ||
            payload?.notification?.title ||
            payload?.data?.title ||
            "Notification";

          const body =
            payload?.body ||
            payload?.notification?.body ||
            payload?.data?.body ||
            "";

          console.log("✅ TITLE:", title);
          console.log("✅ BODY:", body);

          // ================= REMOVE OLD POPUP =================
          const oldPopup = document.getElementById("firebase-popup");

          if (oldPopup) {
            oldPopup.remove();
          }

          // ================= CREATE POPUP =================
          const popup = document.createElement("div");
          popup.id = "firebase-popup";

          popup.innerHTML = `
            <div style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              background: white;
              padding: 25px;
              border-radius: 12px;
              box-shadow: 0 0 20px rgba(0,0,0,0.3);
              z-index: 999999;
              min-width: 320px;
              text-align: center;
              font-family: Arial;
            ">
              <h2 style="margin-bottom: 10px; color: #16a34a;">
                ${title}
              </h2>

              <p style="
                margin-bottom: 20px;
                font-size: 16px;
                color: #333;
              ">
                ${body}
              </p>

              <button id="close-popup-btn" style="
                background: #16a34a;
                color: white;
                border: none;
                padding: 10px 18px;
                border-radius: 8px;
                cursor: pointer;
                font-size: 14px;
              ">
                OK
              </button>
            </div>
          `;

          document.body.appendChild(popup);

          console.log("✅ CENTER POPUP SHOWN");

          // ================= CLOSE BUTTON =================
          setTimeout(() => {
            const closeBtn =
              document.getElementById("close-popup-btn");

            if (closeBtn) {
              closeBtn.onclick = () => {
                popup.remove();
              };
            }
          }, 100);

          // ================= AUTO CLOSE =================
          setTimeout(() => {
            if (popup) {
              popup.remove();
            }
          }, 8000);
        });

        console.log("📡 Listener Attached Successfully");
      } catch (err) {
        console.log("❌ NotificationHandler Error:", err);
      }
    };

    init();

    // ================= CLEANUP =================
    return () => {
      console.log("🧹 Cleaning Notification Listener");

      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return null;
}